const gdpr = {
    title: "GDPR Statement",
    mdcontent: `
      
  ## GDPR Statement
  \n
  Placeholder
  \n
  Please contact the BUIHA using the contact form for any questions or concerns regarding GDPR compliance.
  `,
  };
  export default gdpr;
  